<script setup lang="ts">
import LibraryAnalyticsNode from '@/componentlibrary/LibraryAnalyticsNodeSample.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'

getAnalyticsTracker()
</script>

<template>
  <LibraryAnalyticsNode
    button-id="parent"
    eventName="parent event"
    :event-context="{ parent_property: 'parent value' }"
  >
    <LibraryAnalyticsNode
      button-id="child"
      eventName="child event"
      :event-context="{ child_property: 'child value' }"
    >
      <LibraryAnalyticsNode button-id="grandchild_no-analytics">
        <LibraryAnalyticsNode
          button-id="great-grandchild"
          eventName="great-grandchild event"
          :event-context="{ great_grandchild_property: 'great-grandchild value' }"
        />
      </LibraryAnalyticsNode>
    </LibraryAnalyticsNode>
    <LibraryAnalyticsNode
      button-id="sibling"
      eventName="sibling event"
      :event-context="{ sibling_property: 'sibling value' }"
    />
  </LibraryAnalyticsNode>
</template>
